import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";
import InscricaoDescontoConsultaScreen from "./InscricaoDescontoConsultaScreen";
import { Route, Routes, useNavigate } from "react-router-dom";
import InscricaoDescontoForm from "./InscricaoDescontoForm";
import InscricaoDescontoEditarScreen from "./InscricaoDescontoEditarScreen";
import InscricaoDescontoVisualizarScreen from "./InscricaoDescontoVisualizarScreen";

interface IInscricaoDescontoScreenProps {

}
export default function InscricaoDescontoScreen({
    
}:IInscricaoDescontoScreenProps) {
    const navigate = useNavigate();

    return <Routes>
        <Route path="/" index element={<TelaPermissao tipo="any" permissoes={["DomainViagemInscricaoInscricaoDescontoListarTodos", "DomainViagemInscricaoInscricaoDescontoInserir"]}><InscricaoDescontoConsultaScreen /></TelaPermissao>}></Route>
        <Route path="/Novo" element={
            <TelaPermissao permissoes={["DomainViagemInscricaoInscricaoDescontoInserir"]}>
                <InscricaoDescontoForm
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
        <Route path="/Editar/:codigo" element={
            <TelaPermissao permissoes={["DomainViagemInscricaoInscricaoDescontoAlterar"]}>
                <InscricaoDescontoEditarScreen
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
        <Route path="/Visualizar/:codigo" element={
            <TelaPermissao permissoes={["DomainViagemInscricaoInscricaoDescontoListarPorIdentificador"]}>
                <InscricaoDescontoVisualizarScreen
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
    </Routes>
}